import React from "react";

export const SIDEBAR_NAV_TEST_PROPS = {
  id: "corporate-navigation-bar",
  "data-testid": "corporate-navigationbar-container",
};

export const getNavItemTestProps = (testKey?: string, title?: string) =>
  testKey
    ? {
        id: `corporate-detail-tabs-${testKey}-tab`,
        "data-testid": `corporate-detail-tabs-${testKey}-open`,
        "aria-label": `Visita sezione ${title}`,
      }
    : {};

export const SIDEBAR_HEADER_CORPORATE_TEST_PROPS = {
  id: "corporate-navigation-header-corporate",
  "data-testid": "corporate-navigation-header-corporate",
};

export const SIDEBAR_CORPORATE_SELECT_TEST_PROPS = {
  id: "corporate-navigation-corporate-select",
  "data-testid": "corporate-navigation-corporate-select",
};

export const getCorporateOptionTestProps = (value: string) => ({
  id: `corporate-navigation-corporate-option-${value}`,
  "data-testid": `corporate-navigation-corporate-option-${value}`,
});

export const SIDEBAR_INITIATIVE_SELECT_TEST_PROPS = {
  id: "corporate-navigation-initiative-select",
  "data-testid": "corporate-navigation-initiative-select",
};

export const SIDEBAR_TOGGLE_TEST_PROPS = {
  id: "corporate-navigation-toggle",
  "data-testid": "corporate-navigation-toggle",
};

export const SIDEBAR_OPEN_MENU_TEST_PROPS = {
  id: "corporate-navigation-open-menu",
  "data-testid": "corporate-navigation-open-menu",
};

export const getInitiativeOptionTestProps = (value: string) => ({
  id: `corporate-navigation-initiative-option-${value}`,
  "data-testid": `corporate-navigation-initiative-option-${value}`,
});

export const getSectionTestProps = (testKey?: string) =>
  testKey
    ? {
        id: `corporate-navigation-section-${testKey}`,
        "data-testid": `corporate-navigation-section-${testKey}`,
      }
    : {};

export const getNavActionTestProps = (testKey?: string) =>
  testKey
    ? {
        id: `corporate-detail-tabs-${testKey}-action`,
        "data-testid": `corporate-detail-tabs-${testKey}-action`,
      }
    : {};

export const withNavIconTestProps = (
  icon: React.ReactNode,
  testKey?: string,
): React.ReactNode =>
  testKey && React.isValidElement(icon)
    ? React.cloneElement(icon as React.ReactElement, {
        id: `icon-navigationbar-${testKey}`,
        "data-testid": `icon-navigation-bar-${testKey}`,
      })
    : icon;
